import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { selectors as UserGroupSelectors } from 'data/userGroups'
import { selectors as OrganizationsSelectors } from 'data/organizations'
import { selectors as UsersSelectors } from 'data/users'

import { providesUserGroups } from 'components/Organizations/dataSync/userGroups'
import { Button, Text } from 'components/base'
import emptyPlaceholderSource from './noGroupsIllustration.svg'
import IncentiveBox from 'components/Utils/IncentiveBox'

const UserGroupRow = connect((state, { userGroup }) => {
  return {
    members: UserGroupSelectors.getUserGroupMembers(state, userGroup.id),
  }
})(
  class UserGroupRow extends Component {
    render() {
      return (
        <div className="flexbox flexbox-align-center flexbox-space-between padding-vertical-normal padding-horizontal-medium background-shade-50-on-hover radius-normal">
          <div>
            <span className="font-size-large font-weight-bold">
              {this.props.userGroup.name}
            </span>
            <span className="margin-left-normal shade-20">
              {this.props.members.size} members
            </span>
          </div>

          <Button.Secondary onClick={this.props.onClick}>
            {this.props.actionLabel}
          </Button.Secondary>
        </div>
      )
    }
  }
)

class UserGroups extends Component {
  render() {
    if (
      this.props.fetchUserGroupsState.loading ||
      this.props.fetchUserGroupsState.pristine
    ) {
      return (
        <div className="shade-20 font0weight-medium">
          Loading your groups...
        </div>
      )
    }
    if (!this.props.userGroups.size) {
      return (
        <div className="flexbox flexbox-column flexbox-align-center">
          <img
            className="margin-top-huge"
            src={emptyPlaceholderSource}
            alt="no-group-plceholder-illustration"
          />
          {this.props.showUpgradeIncentive ? (
            <IncentiveBox
              className="flexbox flexbox-column flexbox-align-center margin-top-larger"
              incentiveId="CreateUserGroups"
            />
          ) : (
            <Button.Primary onClick={this.props.goToCreateGroup}>
              Create a group
            </Button.Primary>
          )}
        </div>
      )
    }
    return (
      <div className="padding-vertical-medium">
        <div className="flexbox flexbox-space-between flexbox-align-center margin-bottom-larger">
          <Text.Subtitle>Your groups</Text.Subtitle>
          {!this.props.readOnly && (
            <Button.Primary onClick={this.props.goToCreateGroup}>
              Create a group
            </Button.Primary>
          )}
        </div>

        <div>
          {this.props.userGroups.toArray().map(userGroup => (
            <UserGroupRow
              key={userGroup.id}
              userGroup={userGroup}
              onClick={() => {
                if (this.props.readOnly) {
                  this.props.goToShowGroup(userGroup.id)
                } else {
                  this.props.goToUpdateGroup(userGroup.id)
                }
              }}
              actionLabel={this.props.readOnly ? 'See members' : 'Manage'}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default compose(
  providesUserGroups(),
  connect(state => {
    return {
      readOnly: !UsersSelectors.canCurrentUserManageOrganization(state),
      showUpgradeIncentive: OrganizationsSelectors.isFree(state),
      userGroups: UserGroupSelectors.listOrganizationUserGroups(state),
    }
  })
)(UserGroups)
